export default __webpack_public_path__ + "static/slider-banner-1-3b6ba06de2a4e23009a259500183488a.png";